export const RTL_LANGUAGES = ["AR", "HE", "FA", "UR"];

export const SUPPORTED_LANGUAGES = [
  "EN",
  "TR",
  "NL",
  "DE",
  "IT",
  "FR",
  "ES",
  "PT",
  "HI",
  "AR",
  "UK",
  "PL",
];

export const LANG_MAP = {
  EN: "english",
  TR: "turkish",
  NL: "dutch",
  DE: "german",
  IT: "italian",
  FR: "french",
  ES: "spanish",
  PT: "portuguese",
  HI: "hindi",
  AR: "arabic",
  UK: "ukrainian",
  PL: "polish",
};

export const FOOTER_TYPE = {
  buttonRow: "buttonRow",
  messageInput: "messageInput",
  emailInput: "emailInput",
  otpInput: "otpInput",
  skuTiles: "skuTiles",
  string: "string",
  appStoreTiles: "appStoreTiles",
  none: "none",
};
